import React, {useCallback} from 'react';

import ActiveFilterButton from '../ActiveFilterButton/ActiveFilterButton';

const Category = props => {
    const {event, filterParams, category, value, onFilterRemoved} = props,
        filterIsActive = !!filterParams?.categories?.[category]?.find(v => v == value);

    const handleClick = useCallback(() => app.store.dispatch(app.actions.participants.removeCategoryFilter(event.id, category, value)), [
        event,
        category,
        value,
    ]);

    const handleUnmount = useCallback(() => {
        if (!filterIsActive) {
            onFilterRemoved(category, value);
        }
    }, [filterIsActive, category, value]);

    return (
        <ActiveFilterButton visible={filterIsActive} event={event} onClick={handleClick} onUnmount={handleUnmount} title={`${category}: ${value}`}>
            {value}
        </ActiveFilterButton>
    );
};

export default Category;
